import { apiv1B, apiv1A } from '@/api/axios';

export const modifyAdminPermission = async (userId, emailId, newRole) => {
  const res = await apiv1A.post('/update/admin', {
    user_id: userId,
    email: emailId,
    role: newRole,
  });
  return res;
};
export const getUserList = async (filterBy) => {
  const res = await apiv1B.get('/user/list', {
    params: {
      page_num: filterBy.pageNum,
      page_size: filterBy.pageSize,
      sort_field: filterBy.sortField,
      sort_type: filterBy.sortType,
      search_string: filterBy.searchFilter.searchString,
      search_field: filterBy.searchFilter.searchField,
    },
  });
  return res;
};

export const getOtherUserDetails = async (guid) => {
  const res = await apiv1B.get('/user/details', {
    params: {
      user_id: guid,
    },
  });
  return res;
};
export const fetchTempUserAppdata = async (registeredDateTime) => {
  const res = await apiv1B.get('/user/apps', {
    params: {
      reg_dt_time: registeredDateTime,
    },
  });
  return res;
};
